import { StyleSheet, css } from 'aphrodite';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
// import {
//   EmailShareButton,
//   FacebookShareButton,
//   TwitterShareButton,
//   EmailIcon,
//   FacebookIcon,
//   TwitterIcon,
// } from 'react-share';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { toast } from 'react-toastify';
import { updateAppState } from '../../actions/applicationState';
import { ensureConversationForMatch } from '../../actions/messaging';
import { cancelMatch, endMatch, getDog, requestMatch, toggleFavourite } from '../../actions/pooch';
import { getCurrentMember, updateUser } from '../../actions/user';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import ActivityBadge from '../../components/ActivityBadge';
import CancelRequestModal from '../../components/CancelRequestModal';
import ContentContainer from '../../components/ContentContainer';
import HorizontalRule from '../../components/HorizontalRule';
import MatchRequestModal from '../../components/MatchRequestModal';
import NotificationBar from '../../components/NotificationBar';
import ShareProfile from '../../components/ShareProfile';
import ViewProfileCard from '../../components/ViewProfileCard';

const CHECK_ICON = require('./check.svg');
const LOCATION_ICON = require('./location.svg');
const PAW_ICON = require('./paw.svg');
const HEART_ICON = require('./heart.svg');
const ENVELOPE_ICON = require('./envelope.svg');
const CROSS_ICON = require('./cross.svg');
const PREVIEW_ICON = require('./preview.svg');

class DogProfile extends Component {
  constructor(props) {
    super(props);
    this.setActiveImage = this.setActiveImage.bind(this);
    this.requestMatch = this.requestMatchHandler.bind(this);
    this.requestFavourite = this.requestFavouriteHandler.bind(this);
    this.setSlide = this.setSlide.bind(this);
    this.toggleMatchRequestModal = this.toggleMatchRequestModal.bind(this);
    this.handleMatchRequestSubmit = this.handleMatchRequestSubmit.bind(this);
    this.openCancelRequestModal = this.openCancelRequestModal.bind(this);
    this.closeCancelRequestModal = this.closeCancelRequestModal.bind(this);
    this.handleCancelRequestSubmit = this.handleCancelRequestSubmit.bind(this);
    this.handleMessageOwner = this.handleMessageOwner.bind(this);

    this.state = {
      active_image: null,
      share_requested: false,
      match_request_modal_open: false,
      cancelRequestModalOpen: false,
      cancelRequestMatch: null,
      message_loading: false,
    };
  }

  componentDidMount() {
    this.fetchDog();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.fetchDog();
    }
  }

  getLivingSituationMessage() {
    const dog = this.state.dog;

    if (dog && dog.living_situation && dog.living_situation.length) {
      return `Living Situation: ${dog.living_situation}`;
    }

    return false;
  }

  getAvailabilityMessage() {
    const dog = this.state.dog;

    if (dog && dog.availability && dog.availability.length) {
      return `Availability: ${dog.availability}`;
    }

    return false;
  }

  getRegularityMessage() {
    const dog = this.state.dog;

    if (dog && dog.regularity && dog.regularity.length) {
      return `Regularity: ${dog.regularity}`;
    }

    return false;
  }

  getFixedMessage() {
    const dog = this.state.dog;

    if (dog && dog.fixed) {
      if (dog.fixed === true) {
        return 'Neutered';
      }

      if (dog.fixed === false) {
        return false;
      }

      return dog.fixed;
    }

    return false;
  }

  getDogImage() {
    const dog = this.state.dog;

    if (dog.image_url && dog.image_url.length > 10) {
      return dog.image_url;
    }

    if (dog.profile_photo && dog.profile_photo.length > 10) {
      return dog.profile_photo;
    }

    return '/images/default_dog.jpg';
  }

  getMatches() {
    const dog = this.state.dog;
    const matches = this.props.user.matches;

    return dog && matches && matches.length
      ? this.props.user.matches.filter(match => match.dog && match.dog.id === dog.id)
      : false;
  }

  getFavourites() {
    const dog = this.state.dog;
    const favourites = this.props.user.favourites;

    return dog && favourites && favourites.length
      ? this.props.user.favourites.filter(favourite => favourite && favourite.id === dog.id)
      : false;
  }

  getUserIsPublished() {
    return this.props.user.published;
  }

  getUserOwnsDog() {
    const dog = this.state.dog;
    const userID = parseInt(this.props.user.id, 10);

    return dog && dog.owner_id && parseInt(dog.owner_id, 10) === userID;
  }

  getCurrentMatches() {
    const matches = this.getMatches();

    const currentMatches =
      this.state.dog && matches && matches.length
        ? matches.filter(match => match.status === 'Accepted')
        : false;

    return currentMatches && currentMatches.length ? currentMatches : false;
  }

  getCurrentFavourites() {
    const favourites = this.getFavourites();

    const currentFavourites =
      this.state.dog && favourites && favourites.length
        ? favourites.filter(favourite => favourite.id === this.state.dog.id)
        : false;

    return currentFavourites && currentFavourites.length ? currentFavourites : false;
  }

  getPendingShareRequests() {
    const matches = this.getMatches();

    const pendingRequests =
      this.state.dog && matches ? matches.filter(match => match.status === 'Pending') : false;

    return pendingRequests && pendingRequests.length ? pendingRequests : false;
  }

  setDog(dog) {
    this.setState(
      {
        dog,
        active_image: dog.photos[0] ? dog.photos[0].id : null,
      },
      () => {
        setTimeout(() => {
          this.slider.innerSlider.onWindowResized();
        }, 0);
      },
    );
  }

  setSlide(slide, url) {
    this.setState(
      {
        active_image: url,
      },
      () => {
        this.slider.slickGoTo(slide);
      },
    );
  }

  setActiveImage(photo) {
    this.setState({
      active_image: photo,
    });
  }

  openCancelRequestModal(matchRequest) {
    this.setState({
      cancelRequestModalOpen: true,
      cancelRequestMatch: matchRequest,
    });
  }

  closeCancelRequestModal() {
    this.setState({
      cancelRequestModalOpen: false,
      cancelRequestMatch: null,
    });
  }

  handleCancelRequestSubmit(message) {
    const { cancelRequestMatch } = this.state;

    if (!cancelRequestMatch) {
      this.closeCancelRequestModal();
      return;
    }

    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props
          .dispatch(
            cancelMatch(
              cancelRequestMatch.id,
              this.props.user.access_token,
              typeof message === 'string' ? message.trim() : '',
            ),
          )
          .then(
            () => {
              this.props
                .dispatch(getCurrentMember(this.props.user.id, this.props.user.access_token))
                .then(response => {
                  this.props.dispatch(updateUser(response));

                  this.fetchDog();
                });
            },
            err => {
              console.log(err); // eslint-disable-line
              this.props.dispatch(
                updateAppState({
                  loading: false,
                }),
              );
            },
          );
      });
  }

  handleMessageOwner(match) {
    if (!match || !this.props.user || !this.props.user.access_token) {
      return;
    }

    this.setState({
      message_loading: match.id,
    });

    this.props
      .dispatch(ensureConversationForMatch(match.id, this.props.user.access_token))
      .then(conversation => {
        this.setState({
          message_loading: false,
        });
        this.props.history.push(`/inbox/${conversation.id}`);
      })
      .catch(error => {
        const errorMessage =
          (error && error.data && error.data.error) ||
          error.message ||
          'Unable to open conversation';
        toast.error(errorMessage);
        this.setState({
          message_loading: false,
        });
      });
  }

  fetchDog() {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        if (!this.props.user.access_token) {
          return;
        }

        this.props.dispatch(getDog(this.props.match.params.id, this.props.user.access_token)).then(
          response => {
            this.setDog(response);
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
            this.slider.slickGoTo(0, true);
          },
          err => {
            console.log(err); // eslint-disable-line
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
            this.props.history.push('/404');
          },
        );
      });
  }

  requestMatchHandler() {
    this.setState({
      match_request_modal_open: true,
    });
  }

  requestFavouriteHandler() {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props
          .dispatch(toggleFavourite(this.props.match.params.id, this.props.user.access_token))
          .then(
            () => {
              this.props
                .dispatch(getCurrentMember(this.props.user.id, this.props.user.access_token))
                .then(response => {
                  this.props.dispatch(updateUser(response));

                  this.fetchDog();
                });
            },
            err => {
              console.log(err); // eslint-disable-line
              this.props.dispatch(
                updateAppState({
                  loading: false,
                }),
              );
            },
          );
      });
  }

  endRequest(matchRequest) {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props.dispatch(endMatch(matchRequest.id, this.props.user.access_token)).then(
          () => {
            this.props
              .dispatch(getCurrentMember(this.props.user.id, this.props.user.access_token))
              .then(response => {
                this.props.dispatch(updateUser(response));

                this.fetchDog();
              });
          },
          err => {
            console.log(err); // eslint-disable-line
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
          },
        );
      });
  }

  endFavourite(favourite) {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props.dispatch(toggleFavourite(favourite.id, this.props.user.access_token)).then(
          () => {
            this.props
              .dispatch(getCurrentMember(this.props.user.id, this.props.user.access_token))
              .then(response => {
                this.props.dispatch(updateUser(response));

                this.fetchDog();
              });
          },
          err => {
            console.log(err); // eslint-disable-line
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
          },
        );
      });
  }

  toggleMatchRequestModal() {
    this.setState({
      match_request_modal_open: !this.state.match_request_modal_open,
    });
  }

  handleMatchRequestSubmit(message) {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props
          .dispatch(requestMatch(this.props.match.params.id, message, this.props.user.access_token))
          .then(
            () => {
              this.props
                .dispatch(getCurrentMember(this.props.user.id, this.props.user.access_token))
                .then(response => {
                  this.props.dispatch(updateUser(response));

                  this.fetchDog();
                });
            },
            err => {
              console.log(err); // eslint-disable-line
              this.props.dispatch(
                updateAppState({
                  loading: false,
                }),
              );
            },
          );
      });
  }

  dateOfBirthString() {
    const dobYears = moment().diff(
      moment(this.state.dog.date_of_birth).format('YYYY-MM-DD'),
      'years',
    );
    if (dobYears !== 0) {
      if (dobYears === 1) {
        return dobYears + ' year';
      }

      return dobYears + ' years';
    }

    const dobMonths = moment().diff(
      moment(this.state.dog.date_of_birth).format('YYYY-MM-DD'),
      'months',
    );
    return dobMonths + ' months';
  }

  renderCurrentlySharing() {
    const userOwnsDog = this.getUserOwnsDog();
    const currentMatches = this.getCurrentMatches();
    const requestPending = this.getPendingShareRequests();

    return !userOwnsDog && currentMatches && !requestPending ? (
      <button className={css(styles.action, styles.sharing)}>
        <Isvg
          cacheGetRequests
          src={PAW_ICON}
          className={css(styles.paw_icon, styles.paw_icon_blue, styles.no_action)}
        />
        {"You're"} dog sharing
      </button>
    ) : (
      false
    );
  }

  renderRequestShare() {
    const userOwnsDog = this.getUserOwnsDog();
    const currentMatches = this.getCurrentMatches();
    const requestPending = this.getPendingShareRequests();

    return this.getUserIsPublished() && !userOwnsDog && !currentMatches && !requestPending ? (
      <button onClick={this.requestMatch} className={css(styles.action, styles.share_request)}>
        <Isvg cacheGetRequests src={PAW_ICON} className={css(styles.paw_icon)} />
        Request to share
      </button>
    ) : (
      false
    );
  }

  renderFavourite() {
    const userOwnsDog = this.getUserOwnsDog();
    const currentFavourites = this.getCurrentFavourites();

    return this.getUserIsPublished() && !userOwnsDog && !currentFavourites ? (
      <button
        onClick={this.requestFavourite}
        className={css(styles.action, styles.favourite_request)}
      >
        <Isvg cacheGetRequests src={HEART_ICON} className={css(styles.heart_icon)} />
        Add to favourites
      </button>
    ) : (
      false
    );
  }

  renderDiscontinueFavourite() {
    const currentFavourites = this.getCurrentFavourites();
    const userOwnsDog = this.getUserOwnsDog();

    return !userOwnsDog && currentFavourites ? (
      <button
        onClick={this.endFavourite.bind(this, currentFavourites[0])}
        className={css(styles.action, styles.discontinue_favourite)}
      >
        <Isvg cacheGetRequests src={HEART_ICON} className={css(styles.heart_icon_red)} />
        Remove Favourite
      </button>
    ) : (
      false
    );
  }

  renderMessageAction() {
    const userOwnsDog = this.getUserOwnsDog();
    const currentMatches = this.getCurrentMatches();

    if (userOwnsDog || !currentMatches || !currentMatches.length) {
      return false;
    }

    const primaryMatch = currentMatches[0];
    const isLoading = this.state.message_loading === primaryMatch.id;

    return (
      <button
        onClick={() => this.handleMessageOwner(primaryMatch)}
        className={css(styles.action, styles.message_owner)}
        disabled={isLoading}
      >
        <Isvg cacheGetRequests src={ENVELOPE_ICON} className={css(styles.envelope_icon)} />
        {isLoading ? 'Opening messages...' : 'Message owner'}
      </button>
    );
  }

  renderOwnerProfileButton() {
    const userOwnsDog = this.getUserOwnsDog();
    const currentMatches = this.getCurrentMatches();
    const ownerProfileLink = '/profile/' + this.state.dog.owner_id;

    return !userOwnsDog && currentMatches ? (
      <button
        onClick={() => this.props.history.push(ownerProfileLink)}
        className={css(styles.action, styles.share_request)}
      >
        <Isvg cacheGetRequests src={PREVIEW_ICON} className={css(styles.preview_icon)} />
        View Owners Profile
      </button>
    ) : (
      false
    );
  }

  renderMatchRequestPending() {
    const userOwnsDog = this.getUserOwnsDog();
    const requestsPending = this.getPendingShareRequests();

    return !userOwnsDog && requestsPending ? (
      <button className={css(styles.action, styles.sharing, styles.no_action)}>
        <Isvg
          cacheGetRequests
          src={PAW_ICON}
          className={css(styles.paw_icon, styles.paw_icon_blue)}
        />
        Match request pending
      </button>
    ) : (
      false
    );
  }

  renderDiscontinueSharing() {
    const currentMatches = this.getCurrentMatches();
    const userOwnsDog = this.getUserOwnsDog();

    return !userOwnsDog && currentMatches ? (
      <button
        onClick={this.endRequest.bind(this, currentMatches[0])}
        className={css(styles.action, styles.discontinue_sharing)}
      >
        <Isvg cacheGetRequests src={CROSS_ICON} className={css(styles.cross_icon)} />
        Discontinue Sharing
      </button>
    ) : (
      false
    );
  }

  renderCancelRequest() {
    const userOwnsDog = this.getUserOwnsDog();
    const requestsPending = this.getPendingShareRequests();

    return !userOwnsDog && requestsPending ? (
      <button
        onClick={this.openCancelRequestModal.bind(this, requestsPending[0])}
        className={css(styles.action, styles.discontinue_sharing)}
      >
        <Isvg cacheGetRequests src={CROSS_ICON} className={css(styles.cross_icon)} />
        Cancel request
      </button>
    ) : (
      false
    );
  }

  render() {
    let sliderSettings;
    const cancelMatchRequest = this.state.cancelRequestMatch;
    let cancelModalDogName;
    let cancelModalRecipientName;

    if (cancelMatchRequest && cancelMatchRequest.dog) {
      cancelModalDogName = cancelMatchRequest.dog.name;
      cancelModalRecipientName = cancelMatchRequest.dog.owner_name;
    } else if (this.state.dog) {
      cancelModalDogName = this.state.dog.name;
      cancelModalRecipientName = this.state.dog.owner_name;
    }

    if (this.state.dog) {
      sliderSettings = {
        dots: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: index => {
          if (this.state.dog.photos.length >= 1) {
            this.setSlide(index, this.state.dog.photos[index].id);
          }
        },
      };
    }

    return (
      <div className={css(styles.body)}>
        {this.getUserOwnsDog() ? (
          <NotificationBar>
            <Isvg cacheGetRequests src={PREVIEW_ICON} className={css(styles.preview_icon)} />
            This is how borrowers will view this profile.
            <Link to={`/pooch/${this.state.dog.id}/edit`} className={css(styles.notification_link)}>
              Edit profile
            </Link>
          </NotificationBar>
        ) : (
          false
        )}

        <div className={css(styles.primary_container)}>
          <ContentContainer styles={styles.container}>
            <div className={css(styles.profile)}>
              <div className={css(styles.gallery)}>
                <div className={css(styles.gallery_main)}>
                  <Slider
                    {...sliderSettings}
                    ref={slider => {
                      this.slider = slider;
                    }}
                  >
                    {this.state.dog &&
                    this.state.dog.photos &&
                    this.state.dog.photos.length === 0 ? (
                      <img
                        className={css(styles.gallery_photo)}
                        src={'/images/default_dog.jpg'}
                        alt={this.state.dog && this.state.dog.name ? this.state.dog.name : null}
                      />
                    ) : (
                      false
                    )}
                    {this.state.dog && this.state.dog.photos && this.state.dog.photos.length >= 1
                      ? this.state.dog.photos.map(photo => (
                          <img
                            className={css(styles.gallery_photo)}
                            src={photo.src}
                            alt={this.state.dog && this.state.dog.name ? this.state.dog.name : null}
                          />
                        ))
                      : false}
                  </Slider>
                </div>
                <div className={css(styles.gallery_indicators)}>
                  {this.state.dog && this.state.dog.photos && this.state.dog.photos.length > 1
                    ? this.state.dog.photos.map((photo, index) => (
                        <div
                          className={css(
                            styles.gallery_indicator,
                            this.state.active_image === photo.id
                              ? styles.gallery_indicator_active
                              : null,
                          )}
                          data-photo={photo.src}
                          onClick={() => this.setSlide(index, photo.id)}
                          role="button"
                          tabIndex={0}
                        />
                      ))
                    : false}
                </div>
              </div>
              <div className={css(styles.details)}>
                <h1 className={css(styles.name)}>{this.state.dog ? this.state.dog.name : false}</h1>
                <div className={css(styles.breed)}>
                  {this.state.dog ? this.state.dog.breed : false}
                </div>
                <div className={css(styles.age)}>
                  {this.state.dog && this.state.dog.sex && this.state.dog.sex.length > 0
                    ? `${this.state.dog.sex}${this.state.dog.date_of_birth ? ', ' : false}`
                    : false}
                  {this.state.dog && this.state.dog.date_of_birth
                    ? this.dateOfBirthString() + ' old'
                    : false}
                  {this.getFixedMessage() && this.getFixedMessage().length > 0
                    ? `, ${this.getFixedMessage()}`
                    : false}
                </div>
                <div className={css(styles.location)}>
                  <Isvg
                    cacheGetRequests
                    src={LOCATION_ICON}
                    className={css(styles.location_icon)}
                  />
                  {this.state.dog && this.state.dog.suburb
                    ? `${this.state.dog.suburb.title}, ${this.state.dog.suburb.district.title}`
                    : 'Location not shared'}
                </div>
                {this.state.dog && this.state.dog.plays_with_other_dogs ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    Keen to play with other dogs
                  </div>
                ) : (
                  false
                )}
                {this.state.dog && this.state.dog.good_with_children ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    Good with children
                  </div>
                ) : (
                  false
                )}
                {this.state.dog && this.state.dog.hypoallergenic_coat ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    Hypoallergenic coat
                  </div>
                ) : (
                  false
                )}
                {this.getLivingSituationMessage() ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    {this.getLivingSituationMessage()}
                  </div>
                ) : (
                  false
                )}
                {this.getAvailabilityMessage() ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    {this.getAvailabilityMessage()}
                  </div>
                ) : (
                  false
                )}
                {this.getRegularityMessage() ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    {this.getRegularityMessage()}
                  </div>
                ) : (
                  false
                )}
                {this.getFixedMessage() && this.getFixedMessage() !== 'Entire' ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    {this.getFixedMessage()}
                  </div>
                ) : (
                  false
                )}
              </div>
            </div>
            <div className={css(styles.actionWrap)}>
              {this.state.dog ? (
                <div className={css(styles.actions)}>
                  {this.renderRequestShare()}
                  {this.renderCurrentlySharing()}
                  {this.renderOwnerProfileButton()}
                  {this.renderMatchRequestPending()}
                  {this.renderCancelRequest()}
                  {this.renderMessageAction()}
                  {this.renderDiscontinueSharing()}
                </div>
              ) : (
                false
              )}
              {this.state.dog ? (
                <div className={css(styles.favourites)}>
                  {this.renderFavourite()}
                  {this.renderDiscontinueFavourite()}
                </div>
              ) : (
                false
              )}
              {/* <div className={css(styles.share_icons)}>
                <div className={css(styles.share_icon)}>
                  <EmailShareButton
                    subject="Here is a cool dog"
                    url={window.location.href}>
                    <EmailIcon size={32} round />
                  </EmailShareButton>
                </div>
                <div className={css(styles.share_icon)}>
                  <FacebookShareButton
                    quote="Here is a cool dog"
                    hashtag="thedogsharecollective"
                    url={window.location.href}>
                    <FacebookIcon size={32} round />
                  </FacebookShareButton>
                </div>
                <div className={css(styles.share_icon)}>
                  <TwitterShareButton
                    title="Here is acool dog"
                    hashtags={['thedogsharecollective']}
                    url={window.location.href}>
                    <TwitterIcon size={32} round />
                  </TwitterShareButton>
                </div>
              </div> */}
            </div>
          </ContentContainer>
        </div>
        <div className={css(styles.secondary_container)}>
          <ContentContainer styles={styles.container}>
            <div className={css(styles.sections)}>
              <div className={css(styles.section)}>
                <h2 className={css(styles.section_title)}>About Me</h2>
                <div className={css(styles.section_content)}>
                  <p className={css(styles.section_paragraph)}>
                    {this.state.dog ? this.state.dog.about : false}
                  </p>
                  {this.state.dog ? (
                    <ShareProfile
                      facebook={this.state.dog.facebook_share_url}
                      email={this.state.dog.email_share_url}
                    />
                  ) : null}
                </div>
              </div>
              {this.state.dog && this.state.dog.dogsize && this.state.dog.dogsize.length > 0 ? (
                <HorizontalRule />
              ) : (
                false
              )}
              {this.state.dog && this.state.dog.dogsize && this.state.dog.dogsize.length > 0 ? (
                <div className={css(styles.section)}>
                  <h2 className={css(styles.section_title)}>Size</h2>
                  <div className={css(styles.section_content)}>
                    <p className={css(styles.section_paragraph)}>
                      {this.state.dog ? this.state.dog.dogsize : false}
                    </p>
                  </div>
                </div>
              ) : (
                false
              )}
              {this.state.dog && this.state.dog.interests.length ? <HorizontalRule /> : false}
              {this.state.dog && this.state.dog.interests.length ? (
                <div className={css(styles.section)}>
                  <h2 className={css(styles.section_title)}>{"I'm Interested in"}</h2>
                  <div className={css(styles.section_content)}>
                    <div className={css(styles.activities)}>
                      {this.state.dog.interests.map(interest => (
                        <ActivityBadge activity={interest.title} label styles={styles.activity} />
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                false
              )}
              {this.state.dog && this.state.dog.needs && this.state.dog.needs.length ? (
                <HorizontalRule />
              ) : (
                false
              )}
              {this.state.dog && this.state.dog.needs && this.state.dog.needs.length ? (
                <div className={css(styles.section)}>
                  <h2 className={css(styles.section_title)}>{"I'm good with"}</h2>
                  <div className={css(styles.section_content)}>
                    <ul className={css(styles.bullet_list)}>
                      {this.state.dog.needs.map(need => (
                        <li className={css(styles.bullet_item)}>{need.title}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ) : (
                false
              )}
              {this.state.dog && this.state.dog.health_needs ? <HorizontalRule /> : false}
              {this.state.dog && this.state.dog.health_needs ? (
                <div className={css(styles.section)}>
                  <h2 className={css(styles.section_title)}>Important Details</h2>
                  <div className={css(styles.section_content)}>
                    <p className={css(styles.section_paragraph)}>{this.state.dog.health_needs}</p>
                  </div>
                </div>
              ) : (
                false
              )}

              <HorizontalRule />
            </div>
            {this.state.dog && this.state.dog.related_dogs.length ? (
              <div className={css(styles.side)}>
                <h2 className={css(styles.section_title)}>
                  Dogs like {this.state.dog ? this.state.dog.name : false}
                </h2>
                {this.state.dog && this.state.dog.related_dogs.length
                  ? this.state.dog.related_dogs.map(dog => (
                      <ViewProfileCard
                        id={dog.id}
                        image_url={dog.image_url}
                        name={dog.name}
                        breed={dog.breed}
                      />
                    ))
                  : false}
              </div>
            ) : (
              false
            )}
            <CancelRequestModal
              isOpen={this.state.cancelRequestModalOpen}
              onClose={this.closeCancelRequestModal}
              onSubmit={this.handleCancelRequestSubmit}
              dogName={cancelModalDogName}
              recipientName={cancelModalRecipientName}
            />
            {this.state.dog ? (
              <MatchRequestModal
                isOpen={this.state.match_request_modal_open}
                onClose={this.toggleMatchRequestModal}
                onSubmit={this.handleMatchRequestSubmit}
                dogName={this.state.dog.name}
                ownerName={this.state.dog.owner_name}
              />
            ) : (
              false
            )}
          </ContentContainer>
        </div>
        {this.state.dog && this.state.dog.photos
          ? this.state.dog.photos.map(photo => (
              <img
                src={photo.src}
                alt="Preloaded"
                width="1"
                height="1"
                style={{
                  display: 'none',
                }}
              />
            ))
          : false}
      </div>
    );
  }
}

DogProfile.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const styles = StyleSheet.create({
  share_icons: {
    position: 'relative',
    display: 'inline-block',
    width: '100%',
    textAlign: 'center',
    marginTop: '1rem',
  },
  share_icon: {
    position: 'relative',
    display: 'inline-block',
    marginRight: 10,
    marginLeft: 10,
  },
  body: {
    position: 'relative',
    marginTop: 30,
  },
  preview_icon: {
    marginRight: 10,
  },
  notification_link: {
    marginLeft: 5,
    fontWeight: 'bold',
  },
  cross_icon: {
    position: 'relative',
    top: 1,
    marginRight: 10,
  },
  envelope_icon: {
    position: 'relative',
    top: 3,
    marginRight: 10,
  },
  paw_icon: {
    position: 'relative',
    top: 2,
    marginRight: 10,
    fill: Theme.white,
  },
  paw_icon_blue: {
    fill: '#39b4d6',
  },
  heart_icon: {
    position: 'relative',
    top: 2,
    marginRight: 10,
    fill: '#56C5FF',
  },
  heart_icon_red: {
    position: 'relative',
    top: 2,
    marginRight: 10,
    fill: Theme.red,
  },
  activities: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  activity: {
    marginBottom: 60,

    ':not(:last-child)': {
      marginRight: 35,
    },
  },
  bullet_list: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    marginBottom: -14,
  },
  bullet_item: {
    display: 'flex',
    alignItems: 'center',
    width: '50%',
    marginBottom: 14,
    fontSize: 15,
    lineHeight: 1.53,
    letterSpacing: 0.3,
    color: '#000e1f',
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,

    [Theme.mobile_query]: {
      width: '100%',
    },

    ':before': {
      height: 5,
      width: 5,
      marginRight: 10,
      backgroundColor: '#39b4d6',
      borderRadius: '50%',
      content: '""',
    },
  },
  sections: {
    width: 750,

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  side: {
    width: 360,
    flexShrink: 0,

    [Theme.mobile_query]: {
      width: '100%',
      paddingTop: 50,
    },
  },
  section: {
    display: 'flex',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  section_content: {
    flexGrow: 1,
  },
  section_title: {
    flexShrink: 0,
    width: 195,
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_family_secondary,
    letterSpacing: 1.8,
    color: '#a5a5a5',
    fontSize: 13,
    lineHeight: 1.53,
    textTransform: 'uppercase',

    [Theme.mobile_query]: {
      marginBottom: 15,
    },
  },
  section_paragraph: {
    fontSize: 15,
    lineHeight: 1.53,
    letterSpacing: 0.3,
    color: '#000e1f',
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,

    ':not(:last-child)': {
      marginBottom: 15,
    },
  },
  primary_container: {
    display: 'flex',
    padding: '84px 0 25px',
    backgroundColor: '#F8F8F8',
  },
  secondary_container: {
    padding: '54px 0 150px',

    [Theme.mobile_query]: {
      paddingBottom: 0,
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  profile: {
    display: 'flex',

    [Theme.mobile_query]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
  },
  details: {
    paddingLeft: 38,
    paddingTop: 40,

    [Theme.mobile_query]: {
      paddingLeft: 0,
    },
  },
  name: {
    marginBottom: 18,
    fontSize: 45,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    color: '#000e1f',

    [Theme.mobile_query]: {
      fontSize: 28,
    },
  },
  breed: {
    marginBottom: 17,
    fontSize: 20,
    fontFamily: Theme.font_family_primary,
    fontWeight: 500,
    color: '#000e1f',

    [Theme.mobile_query]: {
      fontSize: 18,
    },
  },
  age: {
    marginBottom: 17,
    fontSize: 20,
    fontFamily: Theme.font_family_primary,
    fontWeight: 500,
    color: '#000e1f',

    [Theme.mobile_query]: {
      fontSize: 18,
    },
  },
  location: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 17,
    fontSize: 15,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    color: '#000e1f',
  },
  location_icon: {
    display: 'block',
    marginRight: 9,
  },
  socialised: {
    display: 'flex',
    alignItems: 'left',
    fontSize: 14,
    fontFamily: Theme.font_family_primary,
    fontWeight: 900,
    paddingTop: 10,
    paddingBottom: 10,
    color: '#000e1f',
  },
  check_icon: {
    display: 'block',
    marginRight: 10.8,
  },
  gallery: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  gallery_main: {
    height: 360,
    width: 360,
    backgroundColor: Theme.grey,

    [Theme.mobile_query]: {
      width: 290,
      height: 'auto',
    },
  },
  gallery_photo: {
    display: 'block',
    height: 360,
    width: 360,
    border: '4px solid #fff',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .1)',
    objectFit: 'cover',

    [Theme.mobile_query]: {
      width: 290,
      height: 'auto',
    },
  },
  gallery_indicators: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
  },
  gallery_indicator: {
    height: 14,
    width: 14,
    margin: '0 10px',
    border: '1px solid #d0d0d0',
    backgroundColor: Theme.white,
    borderRadius: '50%',
    transition: 'all 300ms',
    cursor: 'pointer',
    outline: 'none',
  },
  gallery_indicator_active: {
    borderColor: '#39b4d6',
    backgroundColor: '#39b4d6',
  },
  actions: {
    width: 294,
    paddingTop: 50,

    [Theme.mobile_query]: {
      width: '100%',
      paddingTop: 30,
    },
  },
  favourites: {
    width: 294,
    paddingTop: 20,

    [Theme.mobile_query]: {
      width: '100%',
      paddingTop: 10,
    },
  },
  action: {
    display: 'block',
    marginBottom: 16,
    width: 293,
    height: 50,
    textTransform: 'uppercase',
    fontSize: 15,
    fontFamily: Theme.font_family_secondary,
    fontWeight: 900,
    lineHeight: '50px',
    letterSpacing: 2,
    textAlign: 'center',
    borderRadius: 5,
    border: 0,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    '@media screen and (max-width: 750px)': {
      width: 230,
    },

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  no_action: {
    cursor: 'default',
  },
  share_request: {
    color: Theme.white,
    backgroundColor: Theme.primary,

    ':hover': {
      backgroundColor: '#61c3df',
    },
  },
  favourite_request: {
    color: Theme.primary,
    backgroundColor: Theme.white,
    border: '2px solid #56C5FF',
    ':hover': {
      color: Theme.red,
    },
    ':hover svg': {
      fill: Theme.red,
    },
  },
  message_owner: {
    color: Theme.white,
    backgroundColor: '#000e1f',
    ':disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  discontinue_sharing: {
    color: Theme.white,
    backgroundColor: Theme.error,
  },
  discontinue_favourite: {
    color: Theme.primary,
    backgroundColor: Theme.white,
    border: '2px solid #56C5FF',
    ':hover': {
      color: Theme.red,
    },
  },
  sharing: {
    color: '#000e1f',
    backgroundColor: Theme.white,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DogProfile);



// WEBPACK FOOTER //
// ./src/views/DogProfile/index.js